import { Box, Stack } from "@mui/material";
import React from "react";
import { FontStyle, JobDisplays } from "../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
  JobFontSize,
} from "../../utils/jobUtils";
import DescriptionOverlay from "./DescriptionOverlay";

const styles = {
  container: {
    width: "100%",
    // height: '100%',
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    ...FontStyle.body,
    minWidth: "",
    zIndex: 1,
    position: "relative",
  },
  title: {
    ...FontStyle.headingBody,
    fontSize: JobFontSize.large,
    color: "#000",
    textAlign: "center",
    fontWeight: "bold",
  },
};

const JobBlurbButton = ({ showDescriptionOverlay }) => {
  return (
    <Stack direction="column" sx={styles.container} spacing={1}>
      <DescriptionOverlay
        visible={showDescriptionOverlay}
        name="resourceShort"
      />
      <Box sx={styles.title}>Ready to Unlock Your Job Search Potential?</Box>
      <Box
        sx={{
          ...jobButtonStyle,
          height: "60px",
          // transition: "all 0.3s ease",
          // "&:hover": {
          //   transform: "rotate(360deg)",
          //   backgroundColor: "#5721F1",
          // },
        }}>
        <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
          Download Our Free Resume Template
        </DownloadTemplateWrapper>
      </Box>
    </Stack>
  );
};

export default JobBlurbButton;
